export default __webpack_public_path__ + "static/media/SilverFoilRocket_07.986b8243.png";